import { styled } from '@mui/material';
import { palette } from 'assets/styles/colors';
import Markdown from 'components/Markdown';

const textColor = palette.neutral[600];

export const StyledContent = styled('div')`
  margin-top: 1rem;
`;

export const Terms = styled(Markdown)`
  p,
  li {
    color: ${textColor};
  }

  p {
    margin: 0;
  }
`;
